(function index(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Lightbox = global.NewHomeSource.Lightbox || {};

  if (!global.NewHomeSource.Lightbox.Engine) {
    return;
  }

  class Index {
    /**
     * Initializes a new instance of the class.
     * Sets the template to null and creates a new Lightbox engine instance.
     *
     * @constructor
     */
    constructor() {
      this.template = null;
      this.engine = new global.NewHomeSource.Lightbox.Engine();
    }

    /**
     * Sets the template for the lightbox and returns the current instance for chaining.
     * @param {Node} template - The HTML template to be used.
     * @returns {this} The current instance for method chaining.
     */
    setTemplate(template) {
      this.template = template;
      return this;
    }

    /**
     * Initializes and creates a lightbox carousel using the provided event details.
     *
     * @param {CustomEvent} event - The event containing details for the lightbox, including the media ID.
     */
    create(event) {
      const carouselOptions = {
        containerSelector: '[data-component="lightbox-container-carousel"]',
        loop: true
      };
      const mediaId = event.detail.id || null;
      this.engine.setTemplate(this.template)
        .create(carouselOptions, mediaId);
    }

    /**
     * Binds event listeners required for the lightbox functionality.
     * Specifically, listens for the 'galleryOnPageClick' event on the document body
     * and triggers the creation of the lightbox when the event occurs.
     */
    bindEvents() {
      this.create = this.create.bind(this);
      document.body.addEventListener('galleryOnPageClick', this.create);
    }

    /**
     * Removes the 'galleryOnPageClick' event listener from the document body.
     * This method should be called to clean up event listeners when the lightbox is destroyed.
     */
    destroy() {
      document.body.removeEventListener('galleryOnPageClick', this.create);
      this.engine.destroy();
    }
  }

  global.NewHomeSource.Lightbox.Index = Index;
}(window));
